export const brochurePdf = [
  { name: "wedding", pdf: "./pdfs/MME-wedding-brochure-2023-web-final.pdf" },
  { name: "mitzvahs", pdf: "./pdfs/Barmitzvah-brochure-2023-web.pdf" },
];

export const search = [
  {
    link: "weddings",
    keywords: "Weddings",
    name: "Weddings",
  },
  {
    link: "mitzvahs",
    keywords: "Bar & Bat Mitzvahs",
    name: "Bar & Bat Mitzvahs",
  },
  {
    link: "sweet16s",
    keywords: "Sweet 16S",
    name: "Sweet 16S",
  },
  {
    link: "milestone-celebrations",
    keywords: "Milestone Celebrations",
    name: "Milestone Celebrations",
  },
  {
    link: "aboutus",
    keywords: "About us",
    name: "About us",
  },
  {
    a: "https://tardiscatering.com/",
    keywords: "Tardi's Catering / Food / Beverage /Catering",
    name: "Tardi's Catering / Food / Beverage /Catering",
    text: "Check Out Our Tardi's Catering Site!",
  },
  {
    link: "contact",
    keywords: "Contact us | call | phone number",
    name: "Contact us",
  },
  {
    link: "floral-design-decor",
    keywords: "Event | floral Design And Decor",
    name: "Floral Design And Decor",
  },
  {
    link: "music-entertainment",
    keywords: "Musical Entertainment - Game and More",
    name: "Musical Entertainment",
  },
  {
    link: "lighting",
    keywords: "Lighting",
    name: "Lighting",
  },
  {
    link: "performers",
    keywords: "performers",
    name: "performers",
  },
  {
    link: "lounge-decor-rentals",
    keywords: "lounge decor - Event rentals",
    name: "lounge decor & Event rentals",
  },
  {
    link: "novelty-entertainment",
    keywords: "extra entertainment & novelty",
    name: "extra entertainment & novelty",
  },
  {
    link: "theme-props",
    keywords: "theme props",
    name: "theme props",
  },
];

export const events = [
  {
    link: "weddings",
    name: "Weddings",
  },
  {
    link: "mitzvahs",
    name: "Bar & Bat Mitzvahs",
  },
  {
    link: "sweet16s",
    name: "Sweet 16S",
  },
  {
    link: "milestone-celebrations",
    name: "Milestone Celebrations",
  },
];

export const events_swiper = [
  {
    name: "weddings",
    category: [
      {
        name: "planning",
        images: [
          "./images/event-swiper/wedding/transition-planning-edit.jpg",
          "./images/event-swiper/wedding/planning-transition4.jpg",
          "./images/event-swiper/wedding/transition-planning.JPG",
          "./images/event-swiper/wedding/Transition-planning4-2.jpg",
          "./images/event-swiper/wedding/planning-transition5.jpg",
        ],
        describe:
          "Our experienced team of event planners and designers will help you plan and orchestrate your Wedding from start to finish. The dedicated team at Mikey Mike Events specializes in full-service Wedding Planning for the New York City, Long Island and New Jersey area. Make the choices that you want to make, or develop a creative direction and leave the rest to us. There's no need to make the months leading up to your special day stressful, let Mikey Mike Events take care of everything that you don't want to, and you'll find your expectations exceeded.",
        gallery: [
          "./images/event-swiper/wedding/gallery/static-planning.jpg",
          "./images/event-swiper/wedding/gallery/static-planning8.jpg",
          "./images/event-swiper/wedding/gallery/static-planning10.jpg",
          "./images/event-swiper/wedding/gallery/static-planning11.jpg",
          "./images/event-swiper/wedding/gallery/static-planning12.jpg",
          "./images/event-swiper/wedding/gallery/static-planning13.jpg",
          "./images/event-swiper/wedding/gallery/planning/static-15.jpg",
          "./images/event-swiper/wedding/gallery/planning/static16.jpg",
        ],
      },
      {
        name: "musical entertainment",
        images: [
          "./images/event-swiper/wedding/Musical-Entertainment/transition--violins1.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/transition-jazz2.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/transition-band3.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/transition-DJ4-2.jpg",
        ],
        describe:
          "We are proud to offer our clients the very best in disc jockey or live musical performances. Mikey Mike Events can fulfill all of your live musical needs at your event. Want an a cappella performer to greet your guests in the lobby or to entertain during cocktail hour? How about a high energy DJ, MC, or live band to keep the reception going from start to finish? Or perhaps a special appearance from a high-profile performer for your first dance? We can work with you to ensure everything is perfect and that your wedding sounds exactly how you want it to.",
        gallery: [
          "./images/event-swiper/wedding/Musical-Entertainment/guitar-static.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/harp-static.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/percussion-static.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/static-band.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/static-band2.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/static-bass.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/static-bride-dj.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/static-drumparty.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/static-keys.jpg",
        ],
      },
      {
        name: "lighting",
        images: [
          "./images/event-swiper/wedding/transition-lighting-2.jpg",
          "./images/event-swiper/wedding/transition-lighting2-2.jpg",
          "./images/event-swiper/wedding/transition-lighting5.jpg",
        ],
        describe:
          "Mikey Mike Events lighting designers will provide you with the very best in lighting services for your special day. Lighting can be used to enhance your theme and give your wedding a unique feel, highlight important moments, bring excitement to your reception, and accentuate the visuals of your floral arrangements and décor. Our lighting services include; Ambient Lighting, Pin Lighting, Up Lighting, Personalized Monograms, Intelligent Lighting, LED Lighting, and Laser Light shows.",
        gallery: [
          "./images/event-swiper/wedding/gallery/lighting/static-lighting2.jpg",
          "./images/event-swiper/wedding/gallery/lighting/DSC_0073.jpg",
          "./images/event-swiper/wedding/gallery/lighting/bogo1.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting3-2.jpg",
          "./images/event-swiper/wedding/gallery/lighting/InVision_0539.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting-4.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting4-2.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting5.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting6.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting-6-2.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-artistry.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting.jpg",
        ],
      },
      {
        name: "event & floral design",
        images: [
          "./images/event-swiper/wedding/Floral-Event-design/transition1.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/transition2.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/transition3.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/transition4.jpg",
        ],
        describe:
          "When it comes to your Wedding, it is all about you and bringing your fantasy of your special day to life. Our event design team will combine all aspects of design to create a memorable sensory experience, from striking visuals to floral arrangements and décor, we make sure to include subtle accents that ultimately enhance the experience. Mikey Mike Events will bring everything together in a unified and creative way that will leave you and your partner breathless while being able to enjoy your fantasy wedding, worry-free.",
        gallery: [
          "./images/event-swiper/wedding/Floral-Event-design/static-floral3-2.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/static-floral2-2.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/static-floral4-2.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/static-floral9.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/static2-5.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/static2-7.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/static2-8.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/static-design-11.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/static-design4.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/static3-3.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/static-design1-3.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/static-floral7.JPG",
          "./images/event-swiper/wedding/Floral-Event-design/static-floral10.jpeg",
          "./images/event-swiper/wedding/Floral-Event-design/static-floral8.jpg",
          "./images/event-swiper/wedding/Floral-Event-design/static3-8.jpg",
        ],
      },
      {
        name: "catering",
        images: ["./images/catering.jpg"],
      },
      {
        name: "lounge decor & rentals",
        images: [
          "./images/event-swiper/wedding/Lounge-decor-rentals/transition-rental2.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/transition-rental3.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/transition-rental4.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/transition1.jpg",
        ],
        describe:
          "Mikey Mike Events is proud to offer its clients the very best in Event Décor and Furniture Rental. Rentals allow us to turn any venue into a unique and inspired space to fit the visual style of your fantasy Wedding. Everything you dreamed of is possible as our design team uses Rental Décor and Furniture to create a comfortable dream space for you and your guests. Whether you are inspired by tales of princes and princesses, The Great Gatsby, or something more contemporary, you can be sure we have rentals that can accommodate any visual style you can imagine.",
        gallery: [
          "./images/event-swiper/wedding/Lounge-decor-rentals/static2.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static3.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static4.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static5.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static6.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static7.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static9.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static10.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static-12.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static-couch.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static11.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static12.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static13.jpg",
          "./images/event-swiper/wedding/Lounge-decor-rentals/static14.jpg",
        ],
      },
      {
        name: "after party",
        images: [
          "./images/event-swiper/wedding/gallery/after-party/trasition1.jpg",
          "./images/event-swiper/wedding/gallery/after-party/trasition2.jpg",
          "./images/event-swiper/wedding/gallery/after-party/trasition3.jpg",
        ],
        describe:
          "Why stop the celebration when you don’t have to. Our creative team will help you develop an awesome after party for your wedding night. The options are endless; if you can dream it, we can create it. With the ability to deliver themes such as a “Vegas like” piano bar or “Ibiza style” night club environment at your wedding venue, our talented team has the ability to fulfill all your needs. Let us help you create the perfect ending to a fairytale wedding.",
        gallery: [
          "./images/event-swiper/wedding/gallery/after-party/static1.jpg",
          "./images/event-swiper/wedding/gallery/after-party/static2.jpg",
          "./images/event-swiper/wedding/gallery/after-party/static3.jpg",
          "./images/event-swiper/wedding/gallery/after-party/static5.jpg",
          "./images/event-swiper/wedding/gallery/after-party/static7.jpg",
          "./images/event-swiper/wedding/gallery/after-party/static8.jpg",
          "./images/event-swiper/wedding/gallery/after-party/static9.jpg",
          "./images/event-swiper/wedding/gallery/after-party/static-afterpart2-2.jpg",
          "./images/event-swiper/wedding/gallery/after-party/static-afterpart4-2.jpg",
        ],
      },
      {
        name: "extra entertainment/ Novelty",
        images: [
          "./images/event-swiper/wedding/novelty-entertainment/transition1.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/transition2.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/transition3.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/transition4.jpg",
        ],
        describe:
          "We are proud to offer our clients the very best in disc jockey or live musical performances. Mikey Mike Events can fulfill all of your live musical needs at your event. Want an a cappella performer to greet your guests in the lobby or to entertain during cocktail hour? How about a high energy DJ, MC, or live band to keep the reception going from start to finish? Or perhaps a special appearance from a high-profile performer for your first dance? We can work with you to ensure everything is perfect and that your wedding sounds exactly how you want it to.",
        gallery: [
          "./images/event-swiper/wedding/novelty-entertainment/static1.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static2.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static3.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static4.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static5.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static6.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static7.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static8.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static10.jpg",
        ],
      },
    ],
    video_title: "MIKEY MIKE EVENTS WEDDINGS PROMO",
    video: "https://player.vimeo.com/video/545063526?dnt=1&app_id=122963",
    video_cover: "./images/event-swiper/wedding/wedding.jpg",
    article_title: "WEDDING PLANNING SERVICES",
    article_subheader:
      "We are committed to crafting your dream wedding into reality. Our attention to detail and seamless execution of Wedding services makes us your number one Wedding resource when planning your special day.",
    article:
      "Our team of professionals possess the experience and resources needed to make your Wedding day a huge hit. We can assist you with all your event needs, from the pre-planning stages to on-site coordination; we provide creative and innovative solutions for our Brides and Grooms. Leave the logistics to the pros, we make planning your Wedding an ease allowing you the luxury of being a guest so you may enjoy your own affair.",
    main_img: "./images/event-swiper/wedding/wedding-main.jpg",
  },
  //Event Category break line************************
  {
    name: "bar & bat mitzvahs",
    category: [
      {
        name: "planning",
        images: [
          "./images/event-swiper/mitzvahs/Planning/transition1.JPG",
          "./images/event-swiper/mitzvahs/Planning/transition2.JPG",
          "./images/event-swiper/mitzvahs/Planning/transition3.JPG",
          "./images/event-swiper/mitzvahs/Planning/transition4.JPG",
        ],
        describe:
          "Mike Mike Events specializes in creating unique Bar, Bat, & B'nai Mitzvahs. When selecting the entertainment and production for such a beautiful simcha occasion it is important that you choose the right company to handle such an event. With over 20 years of experience in planning and performing at Bar, Bat & B'nai Mitzvahs, Mike Mike Events is committed to making your dreams become a reality. We will work with you to develop a creative direction for the event and ensure that everything contributes to making your young adult the star of their own celebration.",
        gallery: [
          "./images/event-swiper/mitzvahs/Planning/static1.JPG",
          "./images/event-swiper/mitzvahs/Planning/static2.JPG",
          "./images/event-swiper/mitzvahs/Planning/static3.JPG",
          "./images/event-swiper/mitzvahs/Planning/static5.JPG",
          "./images/event-swiper/mitzvahs/Planning/static6.JPG",
          "./images/event-swiper/mitzvahs/Planning/static7.JPG",
        ],
      },
      {
        name: "lighting",
        images: [
          "./images/event-swiper/mitzvahs/Lighting/transition2.jpg",
          "./images/event-swiper/mitzvahs/Lighting/transition3.jpg",
          "./images/event-swiper/mitzvahs/Lighting/transition4.jpg",
        ],
        describe:
          "Mike Mike Events lighting designers will provide you with the very best in lighting services for your special day. Our design team will help you select the right choice of lighting in order to create the desired ambience for your child's special day. Our lighting services include: Ambient Lighting, Pin Lighting, Up Lighting, Personalized Monograms, Intelligent Lighting, LED Lighting, and Laser Light shows. Give your EDM-loving child a dance floor light show that emulates a music festival, highlight moments of importance, or splash your child's name in lights across the entire venue.",
        gallery: [
          "./images/event-swiper/mitzvahs/Lighting/static2-edit.jpg",
          "./images/event-swiper/mitzvahs/Lighting/static3.jpg",
          "./images/event-swiper/mitzvahs/Lighting/static4.jpg",
          "./images/event-swiper/mitzvahs/Lighting/static6.jpg",
          "./images/event-swiper/mitzvahs/Lighting/static7.jpg",
          "./images/event-swiper/mitzvahs/Lighting/static8.jpg",
          "./images/event-swiper/mitzvahs/Lighting/static9.jpg",
        ],
      },
      {
        name: "Music Entertainment",
        images: [
          "./images/event-swiper/mitzvahs/Entertainment/transition1.jpg",
          "./images/event-swiper/mitzvahs/Entertainment/transition2.jpg",
          "./images/event-swiper/mitzvahs/Entertainment/transition3.jpg",
        ],
        describe:
          "Mikey Mike Events is proud to offer not just musical entertainment, but a wide range of options that leave your child and guests beyond satisfied. Whether it is a high-profile role model of your child delivering a speech and advice for their journey into adulthood, a dance crew performing throughout your event, or a talented visual artist, we can provide a unique experience that truly makes your Bar or Bat Mitzvah an event to be remembered.Whether taking a traditional route or going for an extravagant affair, Mike Mike Events can line up the correct music entertainment to fit your needs. Ensure that your child hears the music they want to hear using the perfect disc jockey or band for your needs. Surprise your child with a special celebrity performance, or make your talented child the star of their own performance. We can mix musical styles as well, allowing a dynamic MC to turn the mundane into the extraordinary by pumping up your guests with a DJ & traditional performer pairing.",
        gallery: [
          "./images/event-swiper/mitzvahs/Entertainment/static2.jpg",
          "./images/event-swiper/mitzvahs/Entertainment/static3.jpg",
          "./images/event-swiper/mitzvahs/Entertainment/static4.jpg",
          "./images/event-swiper/mitzvahs/Entertainment/static5.jpg",
          "./images/event-swiper/mitzvahs/Entertainment/static6.jpg",
          "./images/event-swiper/mitzvahs/Entertainment/static7.jpg",
        ],
      },
      {
        name: "Performers",
        images: [
          "./images/event-swiper/mitzvahs/performers/transition1.jpg",
          "./images/event-swiper/mitzvahs/performers/transition2.jpg",
          "./images/event-swiper/mitzvahs/performers/transition3copy.jpg",
          "./images/event-swiper/mitzvahs/performers/transition4.jpg",
        ],
        describe:
          "We procure top level talent and make it available to you at your event. With a huge roster of talented performers to choose from, we can take your event from ordinary to extraordinary. We provide a variety of performers including magicians, circus-style acts, mentalists, tarot card readers, strolling acts, and much more.",
        gallery: [
          "./images/event-swiper/mitzvahs/performers/static1.jpg",
          "./images/event-swiper/mitzvahs/performers/static2.jpg",
          "./images/event-swiper/mitzvahs/performers/static3.jpg",
          "./images/event-swiper/mitzvahs/performers/static4.jpg",
          "./images/event-swiper/mitzvahs/performers/static5.jpg",
          "./images/event-swiper/mitzvahs/performers/static6.jpg",
          "./images/event-swiper/mitzvahs/performers/static7.jpg",
          "./images/event-swiper/mitzvahs/performers/static8.jpg",
          "./images/event-swiper/mitzvahs/performers/static9.jpg",
          "./images/event-swiper/mitzvahs/performers/static10.jpg",
          "./images/event-swiper/mitzvahs/performers/static11.jpg",
          "./images/event-swiper/mitzvahs/performers/static12.jpg",
          "./images/event-swiper/mitzvahs/performers/static13.jpg",
          "./images/event-swiper/mitzvahs/performers/static14.jpg",
          "./images/event-swiper/mitzvahs/performers/static15.jpg",
          "./images/event-swiper/mitzvahs/performers/static16.jpg",
          "./images/event-swiper/mitzvahs/performers/static17.jpg",
          "./images/event-swiper/mitzvahs/performers/static18.jpg",
          "./images/event-swiper/mitzvahs/performers/static19.jpg",
        ],
      },
      {
        name: "event & floral design",
        images: [
          "./images/event-swiper/mitzvahs/Event-design/transiiton3.jpg",
          "./images/event-swiper/mitzvahs/Event-design/transition1.jpg",
          "./images/event-swiper/mitzvahs/Event-design/transition2.jpg",
          "./images/event-swiper/mitzvahs/Event-design/transition4.jpg",
        ],
        describe:
          "Each and every Bar, Bat, or B'nai Mitzvah that we produce is unique, because we customize your event to your specifications and needs. Mikey Mike Events does all of this while keeping your event budget in mind. We will design and create the ideal experience that your child will remember and be thankful for forever. Whether your goal is a traditional family party, an extravagant party, or an event that makes your child the star of the night, Mikey Mike Events has the tools to make the event happen and exceed all expectations.",
        gallery: [
          "./images/event-swiper/mitzvahs/Event-design/static2-2.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static3-2.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static3.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static5.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static8.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static10.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static12.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static13.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static14.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static15.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static16.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static17.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static20.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static22.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static23.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static24.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static25.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static26.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static27.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static29.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static30.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static31.jpg",
          "./images/event-swiper/mitzvahs/Event-design/static32.jpg",
        ],
      },
      {
        name: "extra entertainment/ Novelty",
        images: [
          "./images/event-swiper/mitzvahs/novelty/transition1.jpg",
          "./images/event-swiper/mitzvahs/novelty/transition2.jpg",
          "./images/event-swiper/mitzvahs/novelty/transition3.jpg",
          "./images/event-swiper/mitzvahs/novelty/transition4.jpg",
        ],
        describe:
          "Each and every Bar, Bat, or B'nai Mitzvah that we produce is unique, because we customize your event to your specifications and needs. Mikey Mike Events does all of this while keeping your event budget in mind. We will design and create the ideal experience that your child will remember and be thankful for forever. Whether your goal is a traditional family party, an extravagant party, or an event that makes your child the star of the night, Mikey Mike Events has the tools to make the event happen and exceed all expectations.",
        gallery: [
          "./images/event-swiper/mitzvahs/novelty/static1.jpg",
          "./images/event-swiper/mitzvahs/novelty/static2.jpg",
          "./images/event-swiper/mitzvahs/novelty/static4.jpg",
          "./images/event-swiper/mitzvahs/novelty/static6.jpg",
          "./images/event-swiper/mitzvahs/novelty/static7.jpg",
          "./images/event-swiper/mitzvahs/novelty/static8.jpg",
          "./images/event-swiper/mitzvahs/novelty/static9-copy.jpg",
          "./images/event-swiper/mitzvahs/novelty/static10.jpg",
          "./images/event-swiper/mitzvahs/novelty/static11.jpg",
          "./images/event-swiper/mitzvahs/novelty/static13.jpg",
          "./images/event-swiper/mitzvahs/novelty/static14.jpg",
          "./images/event-swiper/mitzvahs/novelty/static15.jpg",
          "./images/event-swiper/mitzvahs/novelty/static16.jpg",
          "./images/event-swiper/mitzvahs/novelty/static17.jpg",
          "./images/event-swiper/mitzvahs/novelty/static19.jpg",
          "./images/event-swiper/mitzvahs/novelty/static20.jpg",
          "./images/event-swiper/mitzvahs/novelty/static21.jpg",
          "./images/event-swiper/mitzvahs/novelty/static22.jpg",
          "./images/event-swiper/mitzvahs/novelty/static23.jpg",
          "./images/event-swiper/mitzvahs/novelty/static24.jpg",
        ],
      },
      {
        name: "catering",
        images: ["./images/catering.jpg"],
      },
      {
        name: "lounge decor & rentals",
        images: [
          "./images/event-swiper/mitzvahs/lounge-rental/transition1.jpg",
          "./images/event-swiper/mitzvahs/lounge-rental/transition2.jpg",
          "./images/event-swiper/mitzvahs/lounge-rental/transition3.jpg",
          "./images/event-swiper/mitzvahs/lounge-rental/transition4.jpg",
        ],
        describe:
          "Mikey Mike Events is proud to offer its clients the very best in Event Décor and Furniture Rental. Whether it is from our catalog or something custom designed to fit your child's personality, we can make any Mitzvah a unique experience. Combined with the right Décor, Lighting, and Creative Vision, our rentals mold your venue into exactly how you want it to appear for your child and guests. Make them feel like they are at a Hollywood awards ceremony, a concert, an overseas paradise, or anything you can think of. We will work with you to make it happen.",
        gallery: [
          "./images/event-swiper/mitzvahs/lounge-rental/static1.jpg",
          "./images/event-swiper/mitzvahs/lounge-rental/static2.jpg",
          "./images/event-swiper/mitzvahs/lounge-rental/static4.jpg",
          "./images/event-swiper/mitzvahs/lounge-rental/static5.jpg",
          "./images/event-swiper/mitzvahs/lounge-rental/static6.jpg",
          "./images/event-swiper/mitzvahs/lounge-rental/static7.jpg",
          "./images/event-swiper/mitzvahs/lounge-rental/static8.jpg",
          "./images/event-swiper/mitzvahs/lounge-rental/static9.jpg",
          "./images/event-swiper/mitzvahs/lounge-rental/static10.jpg",
          "./images/event-swiper/mitzvahs/lounge-rental/static11.jpg",
        ],
      },
    ],
    video_title: "BAT MITZVAH TRAILER",
    video: "https://player.vimeo.com/video/559187059?dnt=1&app_id=122963",
    video_cover: "./images/event-swiper/mitzvahs/videocover.png",
    article_title: "BAR & BAT MITZVAH PLANNING SERVICES",
    article_subheader:
      "When planning to celebrate your child's transition into adulthood, there is only one way to do it: the right way.",
    article:
      "Such a special day requires a great deal of planning and we are up to the task. Our seasoned team of event planners have nearly three decades of experience in producing Bar & Bat Mitzvahs. We will assist you in creating an event that is designed to fit your needs while keeping your budget in mind. Providing you with the latest and greatest in Décor, Musical Entertainment, and Production Services, we don't just follow the trends, we help to create them. Partner with us in making your child a trend-setter on their journey into adulthood.",
    main_img: "./images/event-swiper/mitzvahs/mitvah-main.jpg",
  },
  //Event Category break line************************
  {
    name: "sweet 16s",
    category: [
      {
        name: "planning",
        images: [
          "./images/event-swiper/sweet16s/planning/transition1-1.jpg",
          "./images/event-swiper/sweet16s/planning/transition2-2.jpg",
          "./images/event-swiper/sweet16s/planning/transition3.jpg",
          "./images/event-swiper/sweet16s/planning/transition4.jpg",
        ],
        describe:
          "Mike Mike Events is proud to offer its clients the very best in Event Décor and Furniture Rentals. Whether it is from our catalog or something custom designed to fit your teen's personality, we can make any Sweet 16 a unique experience. Combined with the right décor, lighting, and creative vision, our rentals mold your venue into exactly how you want it to appear for your teen and guests. Truly, it will be dreaming with your eyes open, as our rentals put the finishing touches on their Sweet 16 fantasy party.",
        gallery: [
          "./images/event-swiper/sweet16s/planning/static1.jpg",
          "./images/event-swiper/sweet16s/planning/static2.jpg",
          "./images/event-swiper/sweet16s/planning/static3.jpg",
          "./images/event-swiper/sweet16s/planning/static4.jpg",
          "./images/event-swiper/sweet16s/planning/static5.jpg",
          "./images/event-swiper/sweet16s/planning/static6.jpg",
        ],
      },
      {
        name: "music entertainment",
        images: [
          "./images/event-swiper/sweet16s/Music-entertainment/transition-1.jpg",
          "./images/event-swiper/sweet16s/Music-entertainment/transition-2.jpg",
          "./images/event-swiper/sweet16s/Music-entertainment/transition-3.jpg",
          "./images/event-swiper/sweet16s/Music-entertainment/transition-4-2.jpg",
        ],
        describe:
          "Mikey Mike Events knows how to throw a party. Our skills and experience organizing very large affairs for various organizations means that we know how to make your Sweet 16 feel like more than a birthday party. We can take tradition or extravagance to the next level and deliver a musical experience unlike any other. Whether it is Hip Hop, Rock, Pop, Dance, EDM, or a mixture of many styles, we'll give your party the sound it needs. We can combine DJs with live music and the most charismatic of MCs to turn up the celebration to unforgettable levels. Your child can even be the star with a performance of their own, or perhaps you can surprise them with a celebrity performer.",
        gallery: [
          "./images/event-swiper/sweet16s/Music-entertainment/static-band.jpg",
          "./images/event-swiper/sweet16s/Music-entertainment/static-dj.jpg",
          "./images/event-swiper/sweet16s/Music-entertainment/static-planning1.jpg",
          "./images/event-swiper/sweet16s/Music-entertainment/static-violin1.jpg",
          "./images/event-swiper/sweet16s/Music-entertainment/static.jpg",
          "./images/event-swiper/sweet16s/Music-entertainment/static2.jpg",
          "./images/event-swiper/sweet16s/Music-entertainment/static3.jpg",
        ],
      },
      {
        name: "lighting",
        images: [
          "./images/event-swiper/sweet16s/Lighting/transition1.jpg",
          "./images/event-swiper/sweet16s/Lighting/transition2.jpg",
          "./images/event-swiper/sweet16s/Lighting/transition3.jpg",
        ],
        describe:
          "Lighting designers at Mikey Mike Events know how to create mood and ambience, and when given creative direction from our event planners, they can ensure that your Sweet 16 has a unique visual style. We can make your child a brand for the night and feature their name in lights, accent the décor, or pump alongside the music to make the night a visual journey. Our lighting services include: Ambient Lighting, Pin Lighting, Up Lighting, Personalized Monograms, Intelligent Lighting, LED Lighting, and Laser Light shows.",
        gallery: [
          "./images/event-swiper/sweet16s/Lighting/static-light.jpg",
          "./images/event-swiper/sweet16s/Lighting/static-light4.jpg",
          "./images/event-swiper/sweet16s/Lighting/static-light5.jpg",
          "./images/event-swiper/sweet16s/Lighting/static2-edit.jpg",
          "./images/event-swiper/sweet16s/Lighting/static4.jpg",
          "./images/event-swiper/sweet16s/Lighting/static8.jpg",
          "./images/event-swiper/sweet16s/Lighting/static9.jpg",
        ],
      },
      {
        name: "event & floral design",
        images: [
          "./images/event-swiper/sweet16s/Event-Design/transition-1-2.jpg",
          "./images/event-swiper/sweet16s/Event-Design/transition-design2-2.jpg",
          "./images/event-swiper/sweet16s/Event-Design/transition-design3.jpg",
          "./images/event-swiper/sweet16s/Event-Design/transition-design4.jpg",
          "./images/event-swiper/sweet16s/Event-Design/transition1.jpg",
        ],
        describe:
          "Mikey Mike Events specializes in creating a unique experience at every event, and Sweet 16s have the distinction of being some of the most unique affairs we can put on. We can design an event around your creative vision, come up with one of our own, and align that vision to the personality of your child. We bring all of the elements of the party together in a unified form and theme that fits within your budget.",
        gallery: [
          "./images/event-swiper/sweet16s/Event-Design/static-design.jpg",
          "./images/event-swiper/sweet16s/Event-Design/static-design2.jpg",
          "./images/event-swiper/sweet16s/Event-Design/static-design5.jpg",
          "./images/event-swiper/sweet16s/Event-Design/static2.jpg",
          "./images/event-swiper/sweet16s/Event-Design/static6.jpg",
          "./images/event-swiper/sweet16s/Event-Design/static8.jpg",
        ],
      },
      {
        name: "catering",
        images: ["./images/catering.jpg"],
      },
      {
        name: "lounge decor & rentals",
        images: [
          "./images/event-swiper/sweet16s/Rentals/transition-rental.JPG",
          "./images/event-swiper/sweet16s/Rentals/transition-rental2.jpg",
          "./images/event-swiper/sweet16s/Rentals/transition-rental5.jpg",
          "./images/event-swiper/sweet16s/Rentals/transition3.jpg",
        ],
        describe:
          "Mikey Mike Events is proud to offer its clients the very best in Event Décor and Furniture Rentals. Whether it is from our catalog or something custom designed to fit your teen's personality, we can make any Sweet 16 a unique experience. Combined with the right décor, lighting, and creative vision, our rentals mold your venue into exactly how you want it to appear for your teen and guests. Truly, it will be dreaming with your eyes open, as our rentals put the finishing touches on their Sweet 16 fantasy party.",
        gallery: [
          "./images/event-swiper/sweet16s/Rentals/static-artistry.jpg",
          "./images/event-swiper/sweet16s/Rentals/static-lighting1.jpg",
          "./images/event-swiper/sweet16s/Rentals/static-rental2.JPG",
          "./images/event-swiper/sweet16s/Rentals/static-rental6.JPG",
          "./images/event-swiper/sweet16s/Rentals/static-rental7.JPG",
          "./images/event-swiper/sweet16s/Rentals/static-rental8.JPG",
          "./images/event-swiper/sweet16s/Rentals/static5.jpg",
          "./images/event-swiper/sweet16s/Rentals/static9.jpg",
          "./images/event-swiper/sweet16s/Rentals/static11.jpg",
        ],
      },
      {
        name: "extra entertainment/ Novelty",
        images: [
          "./images/event-swiper/sweet16s/Novelty-entertainment/transition-photobooth-edit.jpg",
          "./images/event-swiper/sweet16s/Novelty-entertainment/transition-photobooth4.jpg",
          "./images/event-swiper/sweet16s/Novelty-entertainment/transition1.jpg",
          "./images/event-swiper/sweet16s/Novelty-entertainment/trumpets-transition.jpg",
        ],
        describe:
          "Make the Sweet 16 memorable by enhancing the experience with a show or persistent performance. Whether it is dancers, singers, or visual artists, Mikey Mike Events has the resources to design the perfect supplementary entertainment to your music. This will truly make your Sweet 16 unique.",
        gallery: [
          "./images/event-swiper/sweet16s/Novelty-entertainment/static-novelty18.jpg",
          "./images/event-swiper/sweet16s/Novelty-entertainment/static-novelty19.JPG",
          "./images/event-swiper/sweet16s/Novelty-entertainment/static-photobooth.jpg",
          "./images/event-swiper/sweet16s/Novelty-entertainment/static-photobooth2.jpg",
          "./images/event-swiper/sweet16s/Novelty-entertainment/static-photobooth5.jpg",
          "./images/event-swiper/sweet16s/Novelty-entertainment/static1.jpg",
          "./images/event-swiper/sweet16s/Novelty-entertainment/static2.jpg",
          "./images/event-swiper/sweet16s/Novelty-entertainment/static10.jpg",
          "./images/event-swiper/sweet16s/Novelty-entertainment/static15.jpg",
          "./images/event-swiper/sweet16s/Novelty-entertainment/static16.jpg",
          "./images/event-swiper/sweet16s/Novelty-entertainment/static17.jpg",
        ],
      },
    ],
    video_title: "SWEET 16 TRAILER",
    video: "https://player.vimeo.com/video/192481747?dnt=1&app_id=122963",
    video_cover: "./images/event-swiper/sweet16s/videoCover.png",
    article_title: "SWEET 16 PLANNING SERVICES",
    article_subheader:
      "Your child is turning 16, and you want to deliver them a dream experience that shows them how special they are to you.",
    article:
      "Mikey Mike Events specializes in creating unique and memorable experiences, and that is exactly what a Sweet 16 should be. We'll be sure to create a trend-setting buzz when the affair that we put together exceeds all expectations.",
    main_img: "./images/event-swiper/sweet16s/sweet16-main.jpg",
  },
  //Event Category break line************************
  {
    name: "milestone celebrations",
    category: [
      {
        name: "planning",
        images: [
          "./images/event-swiper/milestone/Planning/transition1.jpg",
          "./images/event-swiper/milestone/Planning/transition2.jpg",
          "./images/event-swiper/milestone/Planning/transition-3.jpg",
          "./images/event-swiper/milestone/Planning/transition-4.jpg",
        ],
        describe:
          "Our planning team stays on top of the latest trends as well as sets the tone for new ones in the event scene, and their attention to detail and desire to put a smile on your face at your own event is second to none. Let our planning team take care of all of the details for you so that you can feel like less of an organizer and more of a guest at your own affair. Be as involved as you want to in the planning process, give us a creative direction to follow, or leave it all up to us. Either way, we will work within your budget to give you the best celebration possible.",
        gallery: [
          "./images/event-swiper/milestone/Planning/static1.jpg",
          "./images/event-swiper/milestone/Planning/static2.jpg",
          "./images/event-swiper/milestone/Planning/static3.jpg",
          "./images/event-swiper/milestone/Planning/static4.jpg",
          "./images/event-swiper/milestone/Planning/static5.jpg",
        ],
      },
      {
        name: "music entertainment",
        images: [
          "./images/event-swiper/wedding/Musical-Entertainment/transition--violins1.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/transition-jazz2.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/transition-band3.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/transition-DJ4-2.jpg",
        ],
        describe:
          "Whether your Milestone Celebration is a low-key dinner or a loud party at a popular venue, we can design the right music program for it. You may desire a solo artist performing a few songs, a DJ complete with an MC, a band, or any combination of these and we know that this talent surpass your expectations.",
        gallery: [
          "./images/event-swiper/wedding/Musical-Entertainment/guitar-static.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/harp-static.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/percussion-static.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/static-band.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/static-band2.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/static-bass.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/static-bride-dj.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/static-drumparty.jpg",
          "./images/event-swiper/wedding/Musical-Entertainment/static-keys.jpg",
        ],
      },
      {
        name: "lighting",
        images: [
          "./images/event-swiper/wedding/transition-lighting-2.jpg",
          "./images/event-swiper/wedding/transition-lighting2-2.jpg",
          "./images/event-swiper/wedding/transition-lighting5.jpg",
        ],
        describe:
          "When it comes to commemorating an important life event, our lighting designers know exactly how to bring your vision to life. Lighting is the subtle difference between creating one mood or another, and our team knows how to use lighting to make an affair appear traditional, contemporary, or something out of a fantasy. Our lighting services include: Ambient Lighting, Pin Lighting, Up Lighting, Personalized Monograms, Intelligent Lighting, LED Lighting, and Laser Light shows.",
        gallery: [
          "./images/event-swiper/wedding/gallery/lighting/static-lighting2.jpg",
          "./images/event-swiper/wedding/gallery/lighting/DSC_0073.jpg",
          "./images/event-swiper/wedding/gallery/lighting/bogo1.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting3-2.jpg",
          "./images/event-swiper/wedding/gallery/lighting/InVision_0539.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting-4.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting4-2.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting5.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting6.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting-6-2.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-artistry.jpg",
          "./images/event-swiper/wedding/gallery/lighting/static-lighting.jpg",
        ],
      },
      {
        name: "event & floral design",
        images: [
          "./images/event-swiper/milestone/Event-Design/transition1.jpg",
          "./images/event-swiper/milestone/Event-Design/transition2.jpg",
        ],
        describe:
          "Our Event Design team will combine all the necessary elements to make your Milestone Celebration unforgettable. You make decisions such as if you want a traditional or extravagant event, your financial parameters and how much input you want to have in the creative aspect of creating this event. Let our Event Design team handle the rest. With some of the most creative minds in the Event Design business, your Milestone Celebration will have all of the elements, big and small, that make your event a stylish affair.",
        gallery: [
          "./images/event-swiper/milestone/Event-Design/static1.jpg",
          "./images/event-swiper/milestone/Event-Design/static2.jpg",
          "./images/event-swiper/milestone/Event-Design/static3.jpg",
          "./images/event-swiper/milestone/Event-Design/static4.jpg",
        ],
      },
      {
        name: "catering",
        images: ["./images/catering.jpg"],
      },
      {
        name: "lounge decor & rentals",
        images: [
          "./images/event-swiper/milestone/lounge-decor-rentals/transition1.jpg",
          "./images/event-swiper/milestone/lounge-decor-rentals/transition2.jpg",
          "./images/event-swiper/milestone/lounge-decor-rentals/transition3.jpg",
          "./images/event-swiper/milestone/lounge-decor-rentals/transition4.jpg",
        ],
        describe:
          "Whether your Milestone Celebration or life event is one often-celebrated or one you are setting a trend by celebrating, our design team works with our rental and fabrication department to bring you a unique experience. With a large stock of rental items and the ability to fabricate our own items, Mikey Mike Events can mold the visual style of any venue into something appropriate for your affair. We make your event a unique one, with décor and accents to match.",
        gallery: [
          "./images/event-swiper/milestone/lounge-decor-rentals/static1.jpg",
          "./images/event-swiper/milestone/lounge-decor-rentals/static3.jpg",
          "./images/event-swiper/milestone/lounge-decor-rentals/static4.jpg",
          "./images/event-swiper/milestone/lounge-decor-rentals/static7.jpg",
          "./images/event-swiper/milestone/lounge-decor-rentals/static9.jpg",
          "./images/event-swiper/milestone/lounge-decor-rentals/static10.jpg",
          "./images/event-swiper/milestone/lounge-decor-rentals/static11.jpg",
        ],
      },
      {
        name: "extra entertainment/ Novelty",
        images: [
          "./images/event-swiper/wedding/novelty-entertainment/transition1.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/transition2.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/transition3.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/transition4.jpg",
        ],
        describe:
          "We are proud to offer our clients the very best in disc jockey or live musical performances. Mikey Mike Events can fulfill all of your live musical needs at your event. Want an a cappella performer to greet your guests in the lobby or to entertain during cocktail hour? How about a high energy DJ, MC, or live band to keep the reception going from start to finish? Or perhaps a special appearance from a high-profile performer for your first dance? We can work with you to ensure everything is perfect and that your wedding sounds exactly how you want it to.",
        gallery: [
          "./images/event-swiper/wedding/novelty-entertainment/static1.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static2.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static3.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static4.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static5.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static6.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static7.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static8.jpg",
          "./images/event-swiper/wedding/novelty-entertainment/static10.jpg",
        ],
      },
    ],
    article_title: "MILESTONE EVENT PLANNING SERVICES",
    article_subheader:
      "It could be anything; a Baptism, an Anniversary, a Graduation Party, or even your own Birthday Party, if it's an occasion that is important to you, it is important to us too.",
    article:
      "Mikey Mike Events makes it our honored duty to make your milestone celebration everything you can hope for and more. We'll make sure you celebrate in style and that all the details are covered.",
    main_img: "./images/event-swiper/milestone/celebration-main.jpg",
  },
];

export const services = [
  {
    link: "floral-design-decor",
    name: "Floral Design & Decor",
    article_title: "Floral Design & Decor",
    article_subheader:
      "Mikey Mike Events can serve you as a full-service boutique, where we can create a direction for you or we can have your own vision materialize before your very eyes. We also maintain an exclusive inventory of décor, allowing us to provide you with a fresh look for your next event across a wide range of styles.",
    article:
      "The design team at MMEink will help you customize your special event from concept to completion. Our rental inventory includes a variety of chic lounges and ornate décor pieces that will transform your space into a spectacular event. Whether custom designed or selected from our exclusive inventory, our creative team will help you select the right choice of furnishings for your affair.",
    main_img: [
      "./images/services/main-img/floral-design-decor/transition-design4.jpg",
      "./images/services/main-img/floral-design-decor/transition-milestone2.JPG",
    ],
    gallery: [
      "./images/services/gallery/floral-design-decor/static-design2.jpg",
      "./images/services/gallery/floral-design-decor/static-floral2.jpg",
      "./images/services/gallery/floral-design-decor/static.jpg",
      "./images/services/gallery/floral-design-decor/static3-1.jpg",
      "./images/services/gallery/floral-design-decor/static3-3.jpg",
      "./images/services/gallery/floral-design-decor/static3-6.jpg",
      "./images/services/gallery/floral-design-decor/static5.jpg",
      "./images/services/gallery/floral-design-decor/static7.jpg",
    ],
  },
  {
    link: "https://tardiscatering.com/",
    name: "Food & Beverage",
  },
  {
    link: "lighting",
    name: "Lighting",
    article_title: "EVENT LIGHTING SERVICES",
    article_subheader:
      "Mikey Mike Events offers a wide range of event planning and management services, including the ability the enhance your celebration from simple to spectacular.",
    article:
      "Our team of lighting designers will set the mood and ambiance for your event by guiding you through our selection of lighting services that will achieve your desired goal. Let us assist your in creating an atmosphere that will astound your guests. With a large choice of lighting services to choose from, we have the ability to accommodate your event's budget and needs. Our services range from simple and sophisticated to extravagant and bold.",
    main_img: [
      "./images/services/main-img/Lighting/transition1.jpg",
      "./images/services/main-img/Lighting/transition2.jpg",
    ],
    subheader: [
      {
        icon: "bi bi-lightbulb",
        name: "Ambient Lighting Services",
        image: [
          "./images/services/subheader-swiper/lighting/ambient-lighting-tab.jpg",
        ],
        describe:
          "Transport your guests to another place or keep them in the here and now. With our variety of both conventional and LED lighting services we will create any atmosphere you can imagine. From Hampton's beach party, to Miami club, to intimate affair, we can match a lighting plan to your creative direction.",
      },
      {
        icon: "bi bi-heart",
        name: "Branded Gobos",
        image: [
          "./images/services/subheader-swiper/lighting/branded-lighting-tab.jpg",
        ],
        describe:
          "Project your wedding or mitzvah logo with customized gobos that will add the perfect touch to your event.",
      },
    ],
    gallery: [
      "./images/services/gallery/lighting/InVision_135.jpg",
      "./images/services/gallery/lighting/WedGal21-35.jpg",
      "./images/services/gallery/lighting/WedGal21-58.jpg",
      "./images/services/gallery/lighting/wedrent-gal-2.jpg",
      "./images/services/gallery/lighting/static-bogo1.jpg",
      "./images/services/gallery/lighting/static-lighting2.jpg",
      "./images/services/gallery/lighting/static8.jpg",
      "./images/services/gallery/lighting/static9.jpg",
    ],
  },
  {
    link: "performers",
    name: "Performers",
    article_title: "TALENTED PERFORMERS",
    article_subheader: "Amaze your guests with talent that delivers!",
    article:
      "We procure top level talent and make it available to you at your event. With a huge roster of talented performers to choose from, we can take your event from ordinary to extraordinary. We provide a variety of performers including magicians, circus-style acts, mentalists, tarot card readers, strolling acts, and much more.",
    main_img: [
      "./images/services/main-img/performers/transition1.jpg",
      "./images/services/main-img/performers/transition2.jpg",
      "./images/services/main-img/performers/transition3.jpg",
    ],
    gallery: [
      "./images/services/gallery/performers/static2.jpg",
      "./images/services/gallery/performers/static3.jpg",
      "./images/services/gallery/performers/static5.jpg",
      "./images/services/gallery/performers/static6.jpg",
      "./images/services/gallery/performers/static7.jpg",
      "./images/services/gallery/performers/static14.jpg",
      "./images/services/gallery/performers/static15.jpg",
      "./images/services/gallery/performers/static18.jpg",
    ],
  },
  {
    link: "music-entertainment",
    name: "Musical Entertainment",
    subheader: [
      {
        icon: "bi bi-speaker-fill",
        name: "DJ Entertainment",
        image: [
          "./images/services/main-img/music-entertainment/transitionDJ.jpg",
          "./images/services/main-img/music-entertainment/transitionDJ2.jpg",
        ],
        describe:
          "Our highly talented DJs are experts at performing live to a diverse crowd and in playing a variety of musical genres. Looking for a fun upbeat vibe? No problem, let us create it for you live at your event. Our DJs are masters at delivering the best in top 40's, classics, hip hop, and EDM. We can even provide you with one of our talented Masters of Ceremonies to host the special day.",
        gallery: [],
      },
    ],
    category: [
      {
        icon: "bi bi-emoji-smile",
        name: "MME LIVE",
        image: [
          "./images/services/main-img/music-entertainment/transition-mmelive.jpg",
          "./images/services/main-img/music-entertainment/transition-mmelive2.jpg",
        ],
        describe:
          "The best thing about MMElive is the variety of options you have for your cocktail hour. Whether you need live musicians, a keyboardist, a saxophone players, a steel drummer, or a DJ we have you covered. Most cocktail hours provide drinks, food and music, but MMElive will provide the best cocktail hour entertainment with live bands, DJ’s, and everything you need.",
      },
      {
        name: "JAZZ",
        video: ["https://player.vimeo.com/video/58670010"],
      },
      {
        name: "KEYBOARD",
        video: ["https://player.vimeo.com/video/803987143?h=41c4c73fbe"],
      },
      {
        name: "SAX",
        video: ["https://player.vimeo.com/video/803990807?h=bafb29243d"],
      },
      {
        name: "HARP",
        video: ["https://player.vimeo.com/video/803983397?h=afedf16d7a"],
      },
      {
        name: "PERCUSSIONS",
        video: ["https://player.vimeo.com/video/58670006"],
      },
      {
        name: "ELECTRIC VIOLINIST",
        video: ["https://player.vimeo.com/video/58670729"],
      },
    ],
    article_title: "ENTERTAINMENT SERVICES",
    article_subheader:
      "We'll exceed your expectations by delivering a custom tailored entertainment program for your event.",
    article:
      "Our services are extensive, providing you with access to celebrity talent and speakers as well as talented musicians and performers. Let us help you design an event that will exceed your guests' expectations. Whether it is designing an entertainment program to open an event or close one, we will have all the resources you need to deliver an amazing experience for your guests.",
    main_img: [
      "./images/services/main-img/music-entertainment/transition1header.jpg",
      "./images/services/main-img/music-entertainment/transition2header.jpg",
      "./images/services/main-img/music-entertainment/transition3header.jpg",
    ],
    gallery: [
      "./images/services/gallery/music-entertainmen/guitar-static.jpg",
      "./images/services/gallery/music-entertainmen/harp-static.jpg",
      "./images/services/gallery/music-entertainmen/static-band.jpg",
      "./images/services/gallery/music-entertainmen/static-violin.jpg",
      "./images/services/gallery/music-entertainmen/static1.jpg",
      "./images/services/gallery/music-entertainmen/static2.jpg",
      "./images/services/gallery/music-entertainmen/static3.jpg",
      "./images/services/gallery/music-entertainmen/static4.jpg",
    ],
  },
  {
    link: "lounge-decor-rentals",
    name: "Lounge Decor & Event Rentals",
    article_title: "Lounge Decor & Event Rentals SERVICES",
    article_subheader:
      "We'll exceed your expectations by delivering a custom tailored entertainment program for your event.",
    article:
      "Our services are extensive, providing you with access to celebrity talent and speakers as well as talented musicians and performers. Let us help you design an event that will exceed your guests' expectations. Whether it is designing an entertainment program to open an event or close one, we will have all the resources you need to deliver an amazing experience for your guests.",
    main_img: [
      "./images/services/main-img/lounge-decor-rental/transition1.jpg",
      "./images/services/main-img/lounge-decor-rental/transition2.jpg",
      "./images/services/main-img/lounge-decor-rental/transition3.jpg",
    ],
    gallery: [
      "./images/services/gallery/lounge-decor-rental/static1.jpg",
      "./images/services/gallery/lounge-decor-rental/static2.jpg",
      "./images/services/gallery/lounge-decor-rental/static3.jpg",
      "./images/services/gallery/lounge-decor-rental/static4.JPG",
      "./images/services/gallery/lounge-decor-rental/static5.jpg",
      "./images/services/gallery/lounge-decor-rental/static7.jpg",
      "./images/services/gallery/lounge-decor-rental/static9.jpg",
      "./images/services/gallery/lounge-decor-rental/static10.jpg",
      "./images/services/gallery/lounge-decor-rental/static11.JPG",
    ],
  },
  {
    link: "novelty-entertainment",
    name: "Extra Entertainment & Novelty",
    article_title: "Extra Entertainment & Novelty SERVICES",
    article_subheader:
      "Make your event event more fun with everything from exciting games to photo booths.",
    article:
      "Mikey Mike Events is know for creating memorable and fun experiences! We can help you choose the perfect specialty entertainment that's sure to be a huge hit at your event. Our services provide you with the very best in casino games, photo booth activities, carnival games, arcade and virtual gaming, and much more. Let us help you select the perfect novelty entertainment to spice up our special event.",
    main_img: [
      "./images/services/main-img/novelty/transition1.jpg",
      "./images/services/main-img/novelty/transition2.jpg",
      "./images/services/main-img/novelty/transition3.jpg",
    ],
    gallery: [
      "./images/services/gallery/novelty/static1.jpg",
      "./images/services/gallery/novelty/static2.jpg",
      "./images/services/gallery/novelty/static3.jpg",
      "./images/services/gallery/novelty/static4.jpg",
      "./images/services/gallery/novelty/static5.jpg",
      "./images/services/gallery/novelty/static6.jpg",
      "./images/services/gallery/novelty/static8.jpg",
      "./images/services/gallery/novelty/static10.jpg",
      "./images/services/gallery/novelty/static11.jpg",
      "./images/services/gallery/novelty/static15.jpg",
      "./images/services/gallery/novelty/static16.jpg",
      "./images/services/gallery/novelty/static24.jpg",
    ],
  },
  {
    link: "theme-props",
    name: "Theme Props",
    article_title: "Theme Props Services",
    article_subheader:
      "We'll exceed your expectations by delivering a custom tailored entertainment program for your event.",
    article:
      "Our services are extensive, providing you with access to celebrity talent and speakers as well as talented musicians and performers. Let us help you design an event that will exceed your guests' expectations. Whether it is designing an entertainment program to open an event or close one, we will have all the resources you need to deliver an amazing experience for your guests.",
    main_img: [
      "./images/services/main-img/theme-prop/transition1.jpg",
      "./images/services/main-img/theme-prop/transition2.jpg",
      "./images/services/main-img/theme-prop/transition3.jpg",
    ],
    gallery: [
      "./images/services/gallery/theme-prop/static1.jpg",
      "./images/services/gallery/theme-prop/static2.jpg",
      "./images/services/gallery/theme-prop/static3.jpg",
      "./images/services/gallery/theme-prop/static4.jpg",
      "./images/services/gallery/theme-prop/static5.jpg",
      "./images/services/gallery/theme-prop/static6.jpg",
      "./images/services/gallery/theme-prop/static7.jpg",
      "./images/services/gallery/theme-prop/static8.jpg",
    ],
  },
];

export const homepageIntro = [
  {
    img: "./images/flip1.jpg",
    header: "Weddings",
    describe:
      "We are committed to crafting your dream wedding into reality. Our attention to detail and seamless execution of Wedding services makes us your number one Wedding resource when planning your special day.",
    learnmore_link: "/weddings",
  },
  {
    img: "./images/flip2.jpg",
    header: "Mitzvahs",
    describe:
      "Such a special day requires a great deal of planning and we are up to the task. Our seasoned team of planners have over two decades of experience in producing amazing Bar & Bat Mitzvah events.",
    learnmore_link: "/Mitzvahs",
  },
  {
    img: "./images/flip3.jpg",
    header: "Sweet 16S",
    describe:
      "We specialize in creating unique and memorable experiences, and that is exactly what a Sweet 16 should be. We'll be sure to create a trend-setting buzz when the affair that we put together exceeds all expectations.",
    learnmore_link: "/sweet16s",
  },
  {
    img: "./images/flip4.jpg",
    header: "Milestone Celebrations",
    describe:
      "It could be anything; a Baptism, an Anniversary, a Graduation Party, or even your own Birthday Party, if it's an occasion that is important to you, it is important to us too.",
    learnmore_link: "/milestone-celebrations",
  },
];
